export const routesAnket = [
  {
    path: "/anket-public/admin/liste",
    name: "anket-public-admin-liste",
    component: () => import("@/views/anket_public/admin/List.vue"),
    meta: {
      public: false,
      title: "Anket Listesi",
      yetki: { k: [1090002] },
    },
  },
  {
    path: "/anket-public/admin/olustur",
    name: "anket-public-admin-olustur",
    component: () => import("@/views/anket_public/admin/Create.vue"),
    meta: {
      public: false,
      title: "Yeni Anket Oluştur",
      yetki: { k: [1090002] },
    },
  },
  {
    path: "/anket-public/admin/duzenle/:id",
    name: "anket-public-admin-duzenle",
    component: () => import("@/views/anket_public/admin/Edit.vue"),
    meta: {
      public: false,
      title: "Anketi Düzenle",
      yetki: { k: [1090002] },
    },
  },
  {
    path: "/anket-public/admin/sonuclar/:id",
    name: "anket-public-admin-sonuclar",
    component: () => import("@/views/anket_public/admin/Results.vue"),
    meta: {
      public: false,
      title: "Anket Sonuçları",
      yetki: { k: [1090002] },
    },
  },
  {
    path: "/anket-public/admin/cevaplar/:id",
    name: "anket-public-admin-cevaplar",
    component: () => import("@/views/anket_public/admin/Responses.vue"),
    meta: {
      public: false,
      title: "Anket Cevapları",
      yetki: { k: [1090002] },
    },
  },

  /* 
  // Public modülde kullanıcı listesi genellikle olmaz, direkt link ile erişilir.
  // İhtiyaç olursa açılabilir.
  {
    path: "/anket-public/user/liste",
    name: "anket-public-user-liste",
    component: () => import("@/views/anket_public/user/List.vue"),
    meta: {
      public: false,
      title: "Anket Listesi",
      yetki: { k: [1090002] }, // Admin yetkisi gerekebilir veya kaldırılabilir
    },
  }, 
  */
  {
    path: "/anket-public/anketler/:uuid",
    name: "anket-public-solve",
    component: () => import("@/views/anket_public/user/Solve.vue"),
    meta: {
      public: true,
      title: "Anket",
      layout: 'blank',

      // Yetki yok (Public)
    },
  },
]
